import { REDUCER } from '../reducers/reducersConst';

export let search = (state = {}, action) => {
  switch (action.type) {
    case REDUCER.SEARCH.SEARCH_RESULTS:
      return {
        ...state,
        searchResult: action.searchResult
      };
    case REDUCER.SEARCH.MODE:
      return {
        ...state,
        searchMode: action.isActive
      };
    default:
      return state;
  }
};
